import { LocationEntity } from '@admin/core/models/location.model';
import { Component, inject } from '@angular/core';
import { CacBaseDialogComponent, CacDialogLayoutComponent } from '@controladad/ng-base';
import { LocationDetailsComponent, LocationDetailsSubmitEvent } from "@admin/shared";
import { LocationApiService } from '@admin/core/services/location-api.service';

export type LocationDialogData = LocationEntity;

export type LocationDialogResult = boolean;

@Component({
  selector: 'app-location-dialog',
  imports: [CacDialogLayoutComponent, LocationDetailsComponent],
  templateUrl: './location-dialog.component.html',
})
export class LocationDialogComponent extends CacBaseDialogComponent<LocationDialogData, LocationDialogResult> {
  private readonly locationApi = inject(LocationApiService);

  onSubmit(v: LocationDetailsSubmitEvent) {
    this.locationApi
      .updateLocation(this.data.id, v.model)
      .pipe(v.e.pipe())
      .subscribe(() => {
        this.submit(true);
      });
  }
}
